export default __webpack_public_path__ + "static/media/sage.0f28162f.png";